/**
 * @generated SignedSource<<985bffc34566ed658dff5a2eb3c73539>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type topBar_issueNavigator_jiraViewResult$data = {
  readonly __typename: string;
  readonly " $fragmentSpreads": FragmentRefs<"SaveResetViewSettingsButton" | "hierarchyToggle_issueNavigator_HierarchyToggleItem" | "src_issueTableHideDoneToggle_HideDoneItemsToggle" | "ui_issueTableGroupByDropdown_GroupByDropdown">;
  readonly " $fragmentType": "topBar_issueNavigator_jiraViewResult";
};
export type topBar_issueNavigator_jiraViewResult$key = {
  readonly " $data"?: topBar_issueNavigator_jiraViewResult$data;
  readonly " $fragmentSpreads": FragmentRefs<"topBar_issueNavigator_jiraViewResult">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewenabledrelayprovider"
    }
  ],
  "kind": "Fragment",
  "name": "topBar_issueNavigator_jiraViewResult",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__typename"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "hierarchyToggle_issueNavigator_HierarchyToggleItem"
        },
        {
          "kind": "FragmentSpread",
          "name": "ui_issueTableGroupByDropdown_GroupByDropdown"
        },
        {
          "kind": "FragmentSpread",
          "name": "src_issueTableHideDoneToggle_HideDoneItemsToggle"
        },
        {
          "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewenabledrelayprovider",
          "kind": "Condition",
          "passingValue": true,
          "selections": [
            {
              "kind": "FragmentSpread",
              "name": "SaveResetViewSettingsButton"
            }
          ]
        }
      ],
      "type": "JiraSpreadsheetView",
      "abstractKey": "__isJiraSpreadsheetView"
    }
  ],
  "type": "JiraView",
  "abstractKey": "__isJiraView"
};

(node as any).hash = "026f7eb7687b3a15033e347bf9fed733";

export default node;
